
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { CustomerData } from '@/hooks/admin/types';

interface SortableTableHeaderProps {
  column: keyof CustomerData;
  label: string;
  sortColumn: keyof CustomerData;
  sortDirection: 'asc' | 'desc';
  handleSort: (column: keyof CustomerData) => void;
}

const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  column,
  label,
  sortColumn,
  sortDirection,
  handleSort
}) => {
  return (
    <Button variant="ghost" onClick={() => handleSort(column)}>
      {label}
      {sortColumn === column && (
        sortDirection === 'asc' 
          ? <ArrowUp className="ml-2 h-4 w-4" /> 
          : <ArrowDown className="ml-2 h-4 w-4" />
      )}
    </Button>
  );
};

export default SortableTableHeader;
